import { useMemo } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import type { AppColors } from '@/constants/theme';
import { useTheme } from '@/contexts/ThemeContext';

type Props = {
  value: number;
  /** Αν δοθεί, τα αστέρια γίνονται επιλέξιμα (1-5). */
  onChange?: (value: number) => void;
  size?: number;
};

export function StarRating({ value, onChange, size = 24 }: Props) {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  const rounded = Math.round(value);
  const interactive = !!onChange;

  return (
    <View style={styles.row}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= rounded;
        const star = (
          <Text style={[styles.star, { fontSize: size, color: filled ? colors.accent : colors.border }]}>
            {filled ? '★' : '☆'}
          </Text>
        );
        if (!interactive) return <View key={i}>{star}</View>;
        return (
          <Pressable
            key={i}
            onPress={() => onChange(i)}
            hitSlop={6}
            accessibilityRole="button"
            accessibilityLabel={t('starRating.starsAccessibilityLabel', { count: i })}
          >
            {star}
          </Pressable>
        );
      })}
    </View>
  );
}

function makeStyles(_colors: AppColors) {
  return StyleSheet.create({
    row: {
      flexDirection: 'row',
      gap: 4,
    },
    star: {
      fontWeight: '400',
    },
  });
}
